import { put, delay } from 'redux-saga/effects'
import * as authenticationCreator from '../Actions/Authentication-creator'
import * as globalPopupHandler from '../Actions/popup-actionCreator'
import axiosInstance from '../../environment/axiosInstances'
import localStorageContent from '../../services/localStorage'
import Cookies from 'js-cookie'

export function* init_auth_saga(action: any): Generator {
    try {
        yield put(authenticationCreator.authLoding(true))
        const authResponse: any = yield axiosInstance.post('/admin/auth/login', action.data);
        if (authResponse.data.data) {
            const { access, refresh } = authResponse.data.data;
            Cookies.set('access', JSON.stringify(access), { expires: new Date(access.expires) })
            Cookies.set('refresh', JSON.stringify(refresh), { expires: new Date(refresh.expires) })
            localStorageContent.setLocalUserData({ authenticated: true, access: access, refresh: refresh })
            yield put(authenticationCreator.authSuccess({ accessToken: access, refreshToken: refresh }))
            yield put(globalPopupHandler.initglobalPopup(authResponse.data.message, 'LOGIN_ROUTE', 'success'))
            yield put(authenticationCreator.initAuthTimeout(access))
            yield put(authenticationCreator.authLoding(false))
        } else {
            yield put(authenticationCreator.authLoding(false))
        }
    } catch (error: any) {
        yield put(authenticationCreator.authLoding(false))
        yield put(globalPopupHandler.initglobalPopup(error.message === 'Network Error' ? 'Network Error' : error.response.data.message, 'LOGIN_ROUTE_FAIL', 'error'))
    }
}

export function* init_auth_timeout(action: any): Generator {
    try {
        const rememberMe: any = yield localStorage.getItem('rememberme');
        const ParseRememeber: any = rememberMe !== undefined ? JSON.parse(rememberMe) : null
        const { expires }: any = action.tokenData;
        const timeOut: any = Math.ceil(new Date(expires).getTime() - new Date().getTime());
        // console.log('auth timeoute-------------', timeOut)
        yield delay(timeOut)
        // console.log('logout----------->', ParseRememeber)
        if (ParseRememeber) {
            yield put(authenticationCreator.initRefreshToken())
        } else {
            yield put(authenticationCreator.initAuthLogout())
        }

    } catch (error) {
        //console.log(error)
    }
}

export function* init_auth_logout(action: any): Generator {
    try {
        yield localStorageContent.setLocalUserData({ authenticated: false, access: null, refresh: null })
        const refreshToken: any = yield Cookies.get('refresh')
        const parseRefresToken = refreshToken !== undefined ? JSON.parse(refreshToken) : undefined;
        if (parseRefresToken !== undefined && parseRefresToken?.token) yield axiosInstance.post('/admin/auth/logout', { refreshToken: parseRefresToken?.token })

        yield Cookies.remove('access')
        yield Cookies.remove('refresh')
        yield put(authenticationCreator.initAuthLogoutSuccess())
    } catch (error) {

    }
}

export function* init_auth_status(): Generator {
    const accessToken: any = Cookies.get('access');
    const refreshToken: any = Cookies.get('refresh');
    const rememberMe: any = localStorage.getItem('rememberme');

    // console.log(accessToken, refreshToken)

    const accessTokenParse = accessToken !== undefined ? JSON.parse(accessToken) : undefined
    const refreshTokenParse = refreshToken !== undefined ? JSON.parse(refreshToken) : undefined
    const parseRemember = rememberMe !== undefined ? JSON.parse(rememberMe) : undefined;

    // console.log(accessTokenParse)

    if (accessTokenParse !== undefined && refreshTokenParse !== undefined) {
        yield put(authenticationCreator.authSuccess({ accessToken: accessTokenParse, refreshToken: refreshTokenParse }))
        yield put(authenticationCreator.initAuthTimeout(accessTokenParse))
    } else if (accessTokenParse === undefined && parseRemember !== undefined && parseRemember === true) {
        yield put(authenticationCreator.initRefreshToken())
    } else {
        yield put(authenticationCreator.initAuthLogout())
    }
}


export function* init_refresh_token(): Generator {
    try {
        const refreshToken: any = yield Cookies.get('refresh')
        const parseRefreshData: any = refreshToken !== undefined ? JSON.parse(refreshToken) : undefined;

        if (parseRefreshData) {
            const responseTokenData: any = yield axiosInstance.post('/admin/auth/refresh-tokens', { refreshToken: parseRefreshData?.token });

            if (responseTokenData.data.data) {
                const { access, refresh } = responseTokenData.data.data;
                yield Cookies.remove('access')
                yield Cookies.remove('refresh')
                yield Cookies.set('access', JSON.stringify(access.token))
                yield Cookies.set('refresh', JSON.stringify(refresh.token))
                yield localStorageContent.setLocalUserData({ authenticated: true, access: access, refresh: refresh })
                yield put(authenticationCreator.authSuccess({ accessToken: access, refreshToken: refresh }))
                yield put(authenticationCreator.initAuthTimeout(access))
            } else {
                yield put(authenticationCreator.initAuthLogout())

            }
        } else {
            yield put(authenticationCreator.initAuthLogout())

        }
    } catch (error) {
        yield put(authenticationCreator.initAuthLogout())

    }
}